import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const specialty = {
  path: '/nationality',
  component: Layout,
  name: 'nationality',
  redirect: '/nationality/index',
  children: [{
    path: '/nationality/index',
    component: () => import('@/views/nationality/index'),
    name: 'nationality.index',
    meta: {
      title: i18n.t(`message.nationality`)
    }
  }, ]
}

export default specialty